import React from 'react';
export class Card extends React.Component {
    constructor(props) {
        super(props);
        this.handleMouseEnter = () => {
            this.setState({ hover: true });
        };
        this.handleMouseLeave = () => {
            this.setState({ hover: false });
        };
        this.render = () => {
            const clickableStyle = this.props.onClick
                ? 'hover:border-primary-600 transition-transform duration-300 ease-out cursor-pointer'
                : '';
            const animationStyle = this.state.hover && this.props.scale && this.props.onClick ? 'scale-105' : '';
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, className: `${this.props.className} min-w-0 p-4 bg-base-700 border-2 rounded-lg border-transparent shadow-xs ${clickableStyle} ${animationStyle}`, style: this.props.style },
                    React.createElement("p", { className: 'mb-4 font-semibold text-base-300' }, this.props.title),
                    React.createElement("p", { className: 'text-base-400' }, this.props.children))));
        };
        this.state = { hover: false };
    }
}
